module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAA50lEQVR4AezUIQjCYBDFcWG4sGJaM66a7XZMEwTBbi9rRrHDejHLOvZl66LNZBEUxPMJS8Odng9NF371vj9feB0RoVzmy+ETe4eNSOBYS6gQIiKGCqRWQcyH2CIiKEEaSoioEENEAAVIiwKCf4SsQd7I+RA9YgHyoYwKUSLGcDOE3GFGhLRuxRnE6Aoje4i+FfKlEwyMIfpWEA7QV0OsW0HYQ08JsW8FYQddS0gOQjBvzKuIDIRj35hmRAgpTFpsDI9tlTsphMyyWn5r9YNl9RAP8RAP8RAP8RAPmcJju4nEyWQ4ZOAxAOEm/bWHONwhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_up.png
// module id = 1661
// module chunks = 1